export function Logo({ className }: { className?: string }) {
  return (
    <img
      src="/logo.png"
      alt="Contract Lucidity"
      className={className || "w-full max-w-[180px]"}
    />
  );
}
